exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.tree {\r\n    list-style :none;\r\n}\r\n.tree .selected{\r\n    color: red;\r\n}\r\n\r\n.tree, .tree ul, .tree li {\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n\r\n.subtree{\r\n    margin-left:20px;\r\n    border-left: 1px solid #ddd;\r\n}\r\n.expand-button{\r\n    width:14px;\r\n    float:left;\r\n    display:block\r\n}    \r\n.selected{\r\n    color:#333 !important;\r\n    font-weight: bold;\r\n}\r\n\r\n.selected i{\r\n    color:red !important;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/directives/tree.css
// module id = ../../../../../src/app/directives/tree.css
// module chunks = main